import React from "react";

import { TypeFiesta } from "@at/design-system-foundation";
import { IconClose } from "@at/design-system-icons";

import * as Styled from "./gallery-close.styled";

interface GalleryCloseButtonProps {
  closeFn?: () => void;
}

export default function GalleryCloseButton({
  closeFn,
}: GalleryCloseButtonProps) {
  return (
    <Styled.GalleryCloseButton
      data-gui="gallery-close"
      data-testid="gallery-close"
      onClick={closeFn}
    >
      <TypeFiesta as="span">Close</TypeFiesta>
      <IconClose
        title={""}
        customSize={{ width: 16, height: 16 }}
        className="modal-icon"
      />
    </Styled.GalleryCloseButton>
  );
}
